import { WE_SPIN_MONTHS, WE_SPIN_WEEKDAYS } from '../constants/we-spin-text-keys.js';

export const ONE_DAY = 1000 * 60 * 60 * 24;

export const difference = start => {
	return +new Date(start).getTime() - +new Date().getTime();
};

export const hours = diff => {
	return Math.floor((diff / (1000 * 60 * 60)) % 24);
};

export const minutes = diff => {
	return Math.floor((diff / 1000 / 60) % 60);
};

export const seconds = diff => Math.trunc(diff / 1000);

export const getWeekDayDateAndMonth = (start, translations) => {
	const date = new Date(start);
	return `${translations[WE_SPIN_WEEKDAYS[date.getDay()]]} ${date.getDate()} ${
		translations[WE_SPIN_MONTHS[date.getMonth()]]
	}`;
};

export const getTimeLeftString = (start, inTimeLeft) => {
	if (start === undefined) {
		return [];
	}

	let timeLeft = {};

	const diff = difference(start);

	if (diff > 0) {
		if (inTimeLeft === undefined) {
			timeLeft = {
				d: Math.floor(diff / ONE_DAY),
				h: hours(diff),
				m: minutes(diff),
				s: Math.floor((diff / 1000) % 60)
			};
		} else {
			timeLeft = inTimeLeft;
		}
	} else {
		return [];
	}

	const timerComponents = [];

	Object.keys(timeLeft).forEach(interval => {
		if (!timeLeft[interval]) {
			return;
		}

		timerComponents.push(
			<span key={interval}>
				{timeLeft[interval]} {interval}{' '}
			</span>
		);
	});

	return timerComponents;
};

export const timeConversion = millisec => {
	const s = (millisec / 1000).toFixed(0);
	const m = (millisec / (1000 * 60)).toFixed(0);
	const h = (millisec / (1000 * 60 * 60)).toFixed(0);
	const d = (millisec / (1000 * 60 * 60 * 24)).toFixed(0);

	if (s < 60) {
		return ` ${s} sec`;
	}
	if (m < 60) {
		return `${m} min`;
	}
	if (h < 24) {
		return ` ${h} h`;
	}
	return ` ${d} d`;
};

export const getGameViewStopTimeLeft = stopTime => {
	let s = difference(stopTime) / 1000;
	const h = Math.floor(s / 3600);
	let m = Math.floor((s - h * 3600) / 60);
	s = Math.ceil(s - h * 3600 - m * 60);

	let time = '';

	if (h !== 0) {
		time = `${h}:`;
	}
	if (m !== 0 || time !== '') {
		m = m < 10 && time !== '' ? `0${m}` : String(m);
		time += `${m}:`;
	}
	if (time === '') {
		time = `${s}s`;
	} else {
		time += s < 10 ? `0${s}` : String(s);
	}
	return time;
};

/**
 * This is used to check for an "active" or "current" session in conjunction with the "live" property.
 * The formula to determine which events go into a session is as follows:
 * startTime + duration + 2h
 *
 * If an event is scheduled for earlier/later than that it will be it's own session.
 *
 * Example:
 * A streamer has 3 scheduled sessions for a sunday with the startTime 12.00, 18.00 and 22.00. The streamer is "Live" for all of these since it's property on the streamer,
 * but we need to figure out for which of these three sessions is the streamer actually live?
 */
export function checkIsSessionActive(session) {
	const { estimatedStartTime, estimatedEndTime } = session;
	const twoHoursInMilliseconds = 7200000;
	const oneHour = twoHoursInMilliseconds / 2;
	const now = new Date().getTime();
	const startTime = new Date(estimatedStartTime).getTime();
	const endTime = new Date(estimatedEndTime).getTime();
	const duration = endTime - startTime;
	const sessionEndTime = new Date(startTime + duration + twoHoursInMilliseconds);
	/* oneHourBeforeEventStart is used to allow the streamer to "go live" one hour before the scheduled session.
	I did not pick one hour as a value for any specific reason other than I thought it was a reasonable amount of time */
	const oneHourBeforeEventStart = startTime - oneHour;
	const isNowWithinSessionEndTime = now > oneHourBeforeEventStart && now < sessionEndTime;

	return isNowWithinSessionEndTime;
}
